// import React , {useState } from 'react';
import { Link } from 'react-router-dom';
// import { useHistory } from 'react-router-dom';
// import { useAuth } from '../AuthContext';
// import Header from './Header';
import { useState } from 'react';
import NewsletterSignup from './NewsletterSignUp';
import Testimonials from './Testimonials';
import PastEvents from '../pages/PastEvents';
// import UpcomingEvent from '../pages/UpcomingEvent';
import LatestBlogPosts from '../pages/Blog';
// import Header from './Header';
import Paris from '../assets/images/slider/paris.jpeg';
import Kingston from '../assets/images/slider/kingston.jpg';
import Bahamas from '../assets/images/slider/bahamas.png';
import Carnival from '../assets/images/slider/carnival_kingston23.jpeg';
import ArtBasel from '../assets/images/slider/art_basel_miami23.jpeg';

import colors from '../theme';

import Community from '../pages/Community';

import FlagBanner from './FlagBanner';
import '../custom.css';
import { useEffect } from 'react';
import { Modal } from 'react-bootstrap';



function Home() {

  // const { currentUser } = useAuth();
  // const { logout } = useAuth();
  // const [preferencesSaved, setPreferencesSaved] = useState(false);
  // const history = useHistory();
  //Custom title of the page



// Hero style
// const heroStyle = {
//   backgroundImage: 'url("https://unieros.com/wp/wp-content/uploads/2022/08/dance_party-scaled.jpg")',
//   backgroundSize: 'cover',
//   backgroundPosition: 'center center',
//   minHeight: '80vh',
//   display: 'flex',
//   flexDirection: 'column',
//   justifyContent: 'center',
//   alignItems: 'center',
//   color: '#fff',
//   opacity: '0.9',
// };
//Create a carousel of multiple images the user can scroll through
const carouselImages = [
  {
    src: `https://unieros.com/wp/wp-content/uploads/2022/08/dance_party-scaled.jpg`,
    alt: 'Unieros multicultural dance event',
    caption: 'Unieros Event',
    category: 'Multicultural Events',
    videoUrl: 'https://www.youtube.com/embed/YsxVHJUaBuA',
    videoTitle: 'Unieros Multicultural Event',
  },
 
  {
    src: `${Paris}`,
    alt: 'Paris',
    caption: 'The Moulin Rouge, Paris',
    category: 'Tours & Travel',
    videoUrl: 'https://www.youtube.com/embed/Aqy-cZw6qmk?si=xi-7hNeP30aAOd3',
    videoTitle: 'Paris, France with Christine',
  },

  {
    src: `${Kingston}`,
    alt: 'Kingston',
    caption: 'Bob Marley Day, Kingston Jamaica',
    category: 'Festivals',
    videoUrl: 'https://www.youtube.com/embed/PTt5cXeP42A?si=jshmgy36EswKeCzo',
  },
  {
    src: `${Bahamas}`,
    alt: 'Bahamas',
    caption: 'Goombay Festival Little Bahamas, Miami',
    category: 'Festivals',
    videoUrl: 'https://www.youtube.com/embed/LpCEdyo4iHs?si=WXb0x1wbdMVT7ZIl',
  },
  {
    src: `${Carnival}`,
    alt: 'Jamaica Carnival',
    caption: 'Jamaica Carnival, Kingston',
    category: 'Ethnic Community Tours',
    videoTitle: 'Jamaica Carnival 2023',
    videoUrl: 'https://www.youtube.com/embed/PTt5cXeP42A?si=tCFeuULQkijxdz9i'
  },
  {
    src: `${ArtBasel}`,
    alt: 'Art Basel Miami 2023',
    caption: 'Art Basel Miami with Argentinian Artist Alfredo Sagatori',
    category: 'Art & Culture',
    videoTitle: 'Art Basel Miami 2023',
    videoUrl: 'https://www.youtube.com/embed/ARMKaSG9550?si=WcWfGagyQRnVrMEC'

  },
];
const carouselStyle = {
  height: '300px', // Set fixed height for carousel
  marginBottom: '20px',
  
};
const [show, setShow] = useState(false);
const [videoUrl, setVideoUrl] = useState('');
const [videoTitle, setVideoTitle] = useState('');

const handleClose = () => setShow(false);
const handleShow = (url, title) => {
  setVideoUrl(url);
  setVideoTitle(title);
  setShow(true);
};

useEffect(() => {
  document.title = 'Unieros - One Love, Many Cultures';
  // const carousel = document.querySelector('.carousel');
//   const carouselInstance = new window.bootstrap.Carousel(carousel, {
//     interval: 5000, // Change image every 5 seconds
//   });
}, []);

//saved preferences
  // const handlePreferencesSaved = () => {
  //   setPreferencesSaved(true);
  // };

  // const showPreferencesForm = () => {
  //   setPreferencesSaved(false);
  // };

  //Logout
  // const handleLogout = async () => {
  //   try {
  //     await logout();
  //     // setIsLoggedIn(false);
  //   } catch (error) {
  //     console.error('Failed to log out:', error);
  //   }
  // };

    return (

      <div className="homepage">
<div className="row">
    <section className="hero-section text-center p-5 homepage-background">
      <h1 className="display-4 text-white">Welcome to Unieros</h1>
      <p className="lead text-white"> Experience the pulse of the world with us. One Love!</p>
      <div className="d-flex justify-content-center">
        <Link to="/events" className="btn m-2 hero-button">Events</Link>
        <Link to="/tours" className="btn m-2 hero-button">Travel</Link>
        <Link to="/tech" className="btn m-2 hero-button">Tech</Link>
      </div>
    </section>
  </div>
  <div className="row">

    <div className="row mb-3 p-3">
      <FlagBanner />
    </div>
  </div>
  <div className="row mb-3 p-3">
  <div className="col-12 home-explore">
    <h2>Connect, Explore, Grow</h2>
    <p>Our curated events and immersive travel experiences are designed to celebrate diversity and unite explorers. Elevate your business with our cutting-edge digital services, tailored with a global edge for growth in a connected world.
 
    </p>
    
  </div>
</div>
      {/* <section className="mt-2 mb-5"> 
      <div className="container">
      <h2 className="text-center mb-4 display-3">Latest Podcast</h2>
      <p className="lead">
        In this episode, we talk to Star Djeene, a African raised in Germany. She shares her experience growing up in Germany and how she navigates her dual identity in a diverse world. 
      </p>
      <p className="shadow p-3 mb-5 bg-body-tertiary rounded">
        <a href="https://www.unieros.com/wp/podcast/both-african-and-german-heritage"><img src="https://unieros.com/wp/wp-content/uploads/2023/09/StarDjeene.jpeg" alt="Unieros Podcast cover art Star Djeene" className="img-fluid" /> </a>
</p>
      </div>
      </section> */}
    
     {/* Login form */}
        {/* <section className="mt-5">
        <div>
          {!currentUser && (
            <LoginForm onLoggedIn={() => {}} />
          )}
          {currentUser && (
            <p>
              You are now logged in!{' '}
              <Link to="/profile" component={Profile}> Click here to update your profile.</Link>
            </p>
          )}
        </div>
        <div>  
        {currentUser && (
          <div>
            <button onClick={handleLogout}>
              Logout
            </button>
          </div>
        )}
            </div>
      </section>
      */}
           { /* Past Unieros Experiences */ }
      <div className="container-fluid">
  <div className="row video-highlights">
    <h2> Unieros Video Highlights</h2>
    <p>Join us on a journey of culture and innovation where every connection broadens your horizon. </p>
    {carouselImages.map((image, index) => (
      <div className="col-lg-4 col-md-6 col-sm-12 p-3" key={index}>
        <div className="card h-100 card-hover" onClick={() => handleShow(image.videoUrl)}>
          <img
            src={image.src}
            alt={image.alt}
            className="card-img-top"
            
          />
          <div className="card-body">
            <h5 className="card-category">{image.category}</h5>
            <h5 className="card-title">{image.caption}</h5>
          </div>
        </div>
      </div>
    ))}
    <Modal show={show} onHide={handleClose} className="brand-modal">
      <Modal.Header closeButton>
        <Modal.Title>{videoTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <iframe
          width="100%"
          height="315"
          src={videoUrl}
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-secondary" onClick={handleClose}>
          Close
        </button>
      </Modal.Footer>
      </Modal>
  </div>
      </div>
          
    
    
     { /* Upcoming event */ }
        <section>
        <div className="container">  
         <Community />

        <div className="row" >
 
          <div style={{ backgroundColor: colors.warmGold, color: colors.neutralGray }} className="mb-4">
          <p className="lead">Unieros Digital Services the 41st International Reggae and World Music Awards
          </p>
          <p>Unieros Digital Services is a new offering took stage as the official social media and digital marketing technical support of the 41st International Reggae and World Music Awards (IRAWMA).For this collaboration, Unieros is providing innovative digital solutions for IRAWMA.</p>
          <p><Link to="/blog" className="btn btn-unieros"> Read more </Link></p>

          </div>
        </div>
        <div className="row">
          <h2 className="display-6">Shop</h2>
          <img src="https://unieros.com/wp/wp-content/uploads/2023/12/mens-t-shirt-regular-black-front.png" alt="Unieros Caribbean Tshirt" className="img-fluid" />
          <p>Get Unieros cultural inspired swag from our cultural canvas online store</p>
          <p><a href="https://unieros.threadless.com/" className="btn btn-unieros">Browse Shop</a></p>
        </div>
         {/* Newsletter Signup */ }
          
         <div className="row">
          <section className="newsletter-signup">
            <div className="container">   
              <NewsletterSignup /> 
            </div>
          </section>
          </div>

     
    </div>

        </section>
      
    
      
      {/* Testimonials */}
      <section className="testimonials py-5">
        <div className="container">
          <Testimonials />
        </div>
      </section>

      {/* Past Events */}
      <section className="past-events py-5">
        <div className="container">
          <PastEvents />
        </div>
      </section>

      {/* Latest Blog Posts */}
      <section className="latest-blog-posts py-5">
        <div className="container">
          <LatestBlogPosts />
        </div>
      </section>
      </div> 
      
    );
  };

  export default Home;
  